import React, { useState } from 'react';
import { TextField, Autocomplete, Select, MenuItem, InputLabel, FormControl, FormGroup, Typography, Box, Divider } from '@mui/material';
import '../../pages/createStudy/createStudy.css';

const StudyFormForAdmin = ({ data }) => {
  const study = data && data[0];

  return (
    <Box sx={{ p: 3, color: '#169a8f', fontWeight: 'bold' }}>
      <Box>
        <Typography variant="h6">Study Criteria</Typography>
        <FormGroup row sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <FormControl sx={{ mr: 3 }}>
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              id="status"
              value={'active'}
              label="Status"
            >
              <MenuItem value="active">Active</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ mr: 3 }}>
            <TextField
              id="phase"
              value={study ? study.phase : ""}
              label="Phase"
            />
          </FormControl>
          <TextField
            id="activation-date"
            label="Activation Date"
            type="date"
            value={study ? new Date(study.createdAt).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)}
            InputLabelProps={{ shrink: true }}
            sx={{ mr: 3 }}
          />
          <TextField
            id="submission-date"
            label="Submission Date"
            type="date"
            value={study ? new Date(study.submissionDate).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)}
            InputLabelProps={{ shrink: true }}
            sx={{ mr: 3 }}
          />
        </FormGroup>

        <TextField value={study ? study.title : ""} id="input-title" label="Title" fullWidth sx={{ mt: 2 }} />

        <TextField value={study ? study.therapeuticAreas : ""} id="input-title" label="Therapeutic Areas" fullWidth sx={{ mt: 2 }} />

        <TextField value={study ? study.indication : ""} id="indication" label="Indication" fullWidth sx={{ mt: 2 }} />
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Study Sponsors</Typography>
        <FormGroup row sx={{ mt: 2 }}>

          <TextField id="name-sponsors" value={study ? study.sponsorName : ""} label="Name Sponsors" sx={{ mr: 3 }} />

          <TextField id="cro" value={study ? study.CRO : ""} label="CRO" />
        </FormGroup>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Divider />
        <Typography variant="h6" sx={{ mt: 2 }}>Criteria</Typography>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="inclusion-criteria"
            label="Inclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={study ? study.inclusionCriteria : ""}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="exclusion-criteria"
            label="Exclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={study ? study.exclusionCriteria : ""}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default StudyFormForAdmin;
